var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74935 8.16663C2.07152 8.16663 2.33268 8.42779 2.33268 8.74996V11.0833C2.33268 11.238 2.39414 11.3864 2.50354 11.4958C2.61293 11.6052 2.76131 11.6666 2.91602 11.6666H11.0827C11.2374 11.6666 11.3858 11.6052 11.4952 11.4958C11.6046 11.3864 11.666 11.238 11.666 11.0833V8.74996C11.666 8.42779 11.9272 8.16663 12.2493 8.16663C12.5715 8.16663 12.8327 8.42779 12.8327 8.74996V11.0833C12.8327 11.5474 12.6483 11.9925 12.3201 12.3207C11.9919 12.6489 11.5468 12.8333 11.0827 12.8333H2.91602C2.45189 12.8333 2.00677 12.6489 1.67858 12.3207C1.35039 11.9925 1.16602 11.5474 1.16602 11.0833V8.74996C1.16602 8.42779 1.42718 8.16663 1.74935 8.16663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67085 5.42085C3.89866 5.19305 4.26801 5.19305 4.49581 5.42085L7 7.92504L9.50419 5.42085C9.73199 5.19305 10.1013 5.19305 10.3291 5.42085C10.557 5.64866 10.557 6.01801 10.3291 6.24581L7.41248 9.16248C7.18467 9.39028 6.81533 9.39028 6.58752 9.16248L3.67085 6.24581C3.44305 6.01801 3.44305 5.64866 3.67085 5.42085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99935 1.16663C7.32152 1.16663 7.58268 1.42779 7.58268 1.74996V8.74996C7.58268 9.07213 7.32152 9.33329 6.99935 9.33329C6.67718 9.33329 6.41602 9.07213 6.41602 8.74996V1.74996C6.41602 1.42779 6.67718 1.16663 6.99935 1.16663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportRoundIcon);
export default __webpack_public_path__ + "static/media/export-round-icon.c7a578568042dfb755b48995b3d1ee4f.svg";
export { ForwardRef as ReactComponent };